<script lang="typescript">
 import LensDetail from './LensDetail.svelte';
 import { variantImages } from '../appData.js';
</script>

<LensDetail title="Anti-Fog" images="{variantImages.antiFog}">
    <div>
	<h2>How does it work:</h2>
	<ul>
	    <li>Anti-Fog lenses absorb the moisture on the lens surface allowing it to be repelled.</li>
	    <li>The Anti-Fog lens solution reduces the surface tension of the moisture allowing it to slip off.</li>
	    <li>For the Anti-Fog lens properties to work you must apply the Anti-Fog lens solution weekly.</li>
	</ul>
	<p>
	    The Antifog lenses will not fog up and provide the customer with a clear vision. For example; whilst drinking a hot drink, walking from indoors to outdoors in lower temperatures, wearing face coverings, opening the oven door.
	</p>
	<h3>Additional benefits:</h3>
	<ul>
	    <li>Enhanced Scratch Resistant</li>
	    <li>Anti-Fog Technology</li>
	</ul>
    </div>
    <div>
	<h2>Who is it suitable for?</h2>
	<ul>
	    <li>Most lifestyles including motorcyclist, PPE wearers and face coverings</li>
	    <li>Most environments going from hot and cold</li>
	    <li>Both adults and children</li>
	</ul>
    </div>
</LensDetail>
